import { createContext } from 'react'

import AppStore from '../mobx/stores/AppStore'
import DealerStore from '../mobx/stores/DealerStore'
import AuthStore from '../mobx/stores/AuthStore'

export const AppStoreContext = createContext(AppStore)
export const DealerStoreContext = createContext(DealerStore)
export const AuthStoreContext = createContext(AuthStore)
